<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        @back="back"
        title="Home"
        :content="$t('importar-filiais')"
      ></el-page-header>
    </el-card>
    <br />
    <el-card>
      <el-steps :active="active" align-center finish-status="success">
        <el-step :title="$t('selecionar-arquivos')"></el-step>
        <el-step :title="$t('validar-dados')"></el-step>
        <el-step :title="$t('importar-filiais')"></el-step>
        <el-step :title="$t('resultado')"></el-step>
      </el-steps>
      <el-row v-if="active === 0" type="flex" justify="center">
        <el-col :span="6">
          <el-upload
            class="upload-demo"
            drag
            action="/api/import/upload/"
            accept=".xls, .csv, .xlsx"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="fileList"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              {{ $t("arraste-aqui-ou") }}
              <em>{{ $t("clique-aqui") }}</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              {{ $t("arquivos-xls") }}
            </div>
          </el-upload>
        </el-col>
      </el-row>
      <el-row v-if="active === 1" type="flex" justify="center">
        <el-col :span="18">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              prop="date"
              :label="$t('cnpj')"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="name"
              :label="$t('filial')"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="address"
              :label="$t('endereco')"
            ></el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row v-if="active === 2" type="flex" justify="center">
        <el-col :span="18">
          <br />
          <el-card class="box-card">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-avatar shape="square" style="display: inline-grid"
                  >123</el-avatar
                >&nbsp;
                <el-tag>Total de linhas arquivos</el-tag>
              </el-col>
              <el-col :span="6">
                <el-avatar shape="square" style="display: inline-grid"
                  >123</el-avatar
                >&nbsp;
                <el-tag>Linhas para importar</el-tag>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
      <el-row v-if="active === 3" type="flex" justify="center">
        <el-col :span="18">
          <el-table
            :data="tableData"
            style="width: 100%"
            :row-class-name="tableRowClassName"
          >
            <el-table-column
              prop="date"
              :label="$t('cnpj')"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="name"
              :label="$t('filial')"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="status"
              :label="$t('status')"
            ></el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-button
        style="margin-top: 12px; float: right"
        v-if="active === 2"
        @click="next"
        >{{ $t("finalizar") }}</el-button
      >
      <el-button
        v-if="active < 2"
        style="margin-top: 12px; float: right"
        @click="next"
        >{{ $t("proximo") }}</el-button
      >
      <el-button
        style="margin-top: 12px; float: right"
        v-if="active !== 0"
        @click="prev"
        >{{ $t("anterior") }}</el-button
      >
    </el-card>
  </div>
</template> 
<script>
//import { CustomerService } from "@/services/customers/customers.services";
import { CpfHelpers } from "@/xpost/helpers/cpf";
import { CnpjHelpers } from "@/xpost/helpers/cnpj";
import { i18n } from "@/plugin/i18n";
import ZipMixins from "../../../mixins/zipcode";

export default {
  name: "CustomerAdd",
  mixins: [ZipMixins],
  data() {
    var checkCpf = (rule, value, callback) => {
      const vm = this;
      if (vm.ruleForm.type === "2") {
        return callback();
      }
      CpfHelpers.checkCpf(rule, value, callback);
    };
    var checkCnpj = (rule, value, callback) => {
      const vm = this;
      if (vm.ruleForm.type === "1") {
        return callback();
      }
      CpfHelpers.checkCnpj(rule, value, callback);
    };
    return {
      id: "",
      activeTab: "address",
      active: 0,
      fileList: [],
      ruleForm: {
        name: "",
        companyname: "",
        type: "1",
        cpf: "",
        cnpj: "",
        registermunicipal: "",
        registerstate: "",
        mail: "",
        cep: "",
        address: "",
        city: "",
        state: "",
        neighborhood: "",
        number: "",
        extent: "",
        phone: {
          commercial: "",
          residential: "",
          cellphone: "",
        },
      },
      tableData: [
        {
          date: "01.001.001/0001-01",
          name: "Filial 1",
          address: "No. 189, Grove St, Los Angeles",
          status: "Importado com sucesso",
        },
        {
          date: "01.001.001/0001-01",
          name: "Filial 2",
          address: "No. 189, Grove St, Los Angeles",
          status: "Filial já relacionada",
        },
        {
          date: "01.001.001/0001-01",
          name: "Filial 3",
          address: "No. 189, Grove St, Los Angeles",
          status: "Importado com sucesso",
        },
        {
          date: "01.001.001/0001-01",
          name: "Filial 4",
          address: "No. 189, Grove St, Los Angeles",
          status: "Importado com sucesso",
        },
      ],
      rules: {
        name: [
          {
            required: true,
            message: i18n.tc("nome-fantasia-obrigatorio"),
            trigger: "blur",
          },
        ],
        companyname: [
          {
            required: true,
            message: i18n.tc("razao-social-obrigatorio"),
            trigger: "blur",
          },
        ],
        cpf: {
          validator: checkCpf,
          trigger: "blur",
        },
        cnpj: {
          validator: checkCnpj,
          trigger: "blur",
        },
      },
    };
  },
  methods: {
    handlePreview() {},
    handleRemove() {},
    next() {
      if (this.active++ > 3) this.active = 0;
    },
    prev() {
      if (this.active-- < 0) this.active = 0;
    },
    back() {
      var vm = this;
      vm.$router.push("/cadastro/filial").catch(() => {});
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      }
      return "";
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        /*
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          CustomerService.add(
            vm.ruleForm.name,
            vm.ruleForm.companyname,
            vm.ruleForm.type,
            vm.ruleForm.type === "1" ? vm.ruleForm.cpf : vm.ruleForm.cnpj,
            vm.ruleForm.registermunicipal,
            vm.ruleForm.registerstate,
            vm.ruleForm.mail,
            vm.ruleForm.phone.commercial,
            vm.ruleForm.phone.residential,
            vm.ruleForm.phone.cellphone,
            vm.ruleForm.cep,
            vm.ruleForm.address,
            vm.ruleForm.neighborhood,
            vm.ruleForm.city,
            vm.ruleForm.state,
            vm.ruleForm.number,
            vm.ruleForm.extent
          )
            .then(response => {
              this.$message({
                type: "success",
                message: i18n.tc("cliente-adicionado-sucesso")
              });
              this.$refs[formName].resetFields();
            })
            .catch(error => {
              this.$message({
                type: "error",
                message: error
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }*/
      });
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        /*        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          CustomerService.update(
            vm.id,
            vm.ruleForm.name,
            vm.ruleForm.companyname,
            vm.ruleForm.type,
            vm.ruleForm.type === "1" ? vm.ruleForm.cpf : vm.ruleForm.cnpj,
            vm.ruleForm.registermunicipal,
            vm.ruleForm.registerstate,
            vm.ruleForm.mail,
            vm.ruleForm.phone.commercial,
            vm.ruleForm.phone.residential,
            vm.ruleForm.phone.cellphone,
            vm.ruleForm.cep,
            vm.ruleForm.address,
            vm.ruleForm.neighborhood,
            vm.ruleForm.city,
            vm.ruleForm.state,
            vm.ruleForm.number,
            vm.ruleForm.extent
          )
            .then(response => {
              this.$message({
                type: "success",
                message: i18n.tc("cliente-atualizado-sucesso")
              });
            })
            .catch(error => {
              this.$message({
                type: "error",
                message: error
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }*/
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    const vm = this;
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      vm.get();
    }
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}

.el-table .success-row {
  background: #f0f9eb;
}
form {
  margin-top: 20px;
}
@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
